import bowser from 'bowser';
import classNames from 'classnames';
import bindAll from 'lodash.bindall';
import PropTypes from 'prop-types';
import React from 'react';
import { defineMessages, FormattedMessage, injectIntl, intlShape } from 'react-intl';
import { connect } from 'react-redux';
import { compose } from 'redux';

import VM from 'scratch-vm';

import AccountNav from '../../containers/account-nav.jsx';
import LanguageSelector from '../../containers/language-selector.jsx';
import ProjectWatcher from '../../containers/project-watcher.jsx';
import SBFileUploader from '../../containers/sb-file-uploader.jsx';
import Box from '../box/box.jsx';
import Button from '../button/button.jsx';
import { ComingSoonTooltip } from '../coming-soon/coming-soon.jsx';
import Divider from '../divider/divider.jsx';
import { MenuItem, MenuSection } from '../menu/menu.jsx';
import AuthorInfo from './author-info.jsx';
import CommunityButton from './community-button.jsx';
import MenuBarMenu from './menu-bar-menu.jsx';
import ProjectTitleInput from './project-title-input.jsx';
import SaveStatus from './save-status.jsx';
import ShareButton from './share-button.jsx';
// import LoginDropdown from './login-dropdown.jsx';
import DeletionRestorer from '../../containers/deletion-restorer.jsx';
import EducabotSaver from '../../containers/educabot-saver.jsx';
import MenuBarHOC from '../../containers/menu-bar-hoc.jsx';
import SB3Downloader from '../../containers/sb3-downloader.jsx';
import TurboMode from '../../containers/turbo-mode.jsx';
import LoginDropdown from '../login/login-dropdown.jsx';

import {
    accountMenuOpen,
    closeAccountMenu,
    closeDetailsProjectMenu,
    closeEditMenu,
    closeFileMenu,
    closeLanguageMenu,
    closeLoginMenu,
    closeProfileMenu,
    closeRegistrationMenu,
    closeRemixProjectMenu,
    closeSaveProjectMenu,
    detailsProjectOpenState,
    editMenuOpen,
    fileMenuOpen,
    languageMenuOpen,
    loginMenuOpen,
    openAccountMenu,
    openEditMenu,
    openFileMenu,
    openLanguageMenu,
    openLoginMenu,
    openProfileMenu,
    openProfileState,
    openRegistrationMenu,
    openRemixProjectMenu,
    openSaveProjectMenu,
    registrationOpenState,
    remixProjectOpenState,
    saveProjectOpenState
} from '../../reducers/menus';
import {
    closeProjectsLibrary,
    openProjectsLibrary,
    openTipsLibrary
} from '../../reducers/modals';
import { setPlayer } from '../../reducers/mode';
import { activateDeck } from '../../reducers/project-details-card';
import {
    autoUpdateProject,
    getIsAssignmentProjectDeliverable,
    getIsShowingProject,
    getIsShowingWithId,
    getIsUpdating,
    manualUpdateProject,
    remixProject,
    requestNewProject,
    saveProjectAsCopy,
} from '../../reducers/project-state';

import './react-upload-image.scss';
import './UserProfileSidebar.scss';
import collectMetadata from '../../lib/collect-metadata';
import {
    checkAuthAction,
    handleLogin,
    handleLogout
} from '../../reducers/session';
import Scratch3Registration from '../registration/scratch3-registration.jsx';
// const Scratch3Registration = require('../registration/scratch3-registration.jsx').default;
import ProjectSaving from '../project/project-saving.jsx';

import styles from './menu-bar.css';

// import mystuffIcon from './icon--mystuff.png';
// import profileIcon from './icon--profile.png';
import languageIcon from '../language-selector/language-icon.svg';
import dropdownCaret from './dropdown-caret.svg';
import aboutIcon from './icon--about.svg';
import remixIcon from './icon--remix.svg';


import sharedMessages from '../../lib/shared-messages';

// import scratchLogo from '../../../static/assets/logo.svg';
import { getLogo } from './../../lib/cosmos';
const logo = `../../../static/assets/${getLogo()}`;
// const { UserProfileSidebar } = components.default;

const ariaMessages = defineMessages({
    language: {
        id: 'gui.menuBar.LanguageSelector',
        defaultMessage: 'language selector',
        description: 'accessibility text for the language selection menu'
    },
    tutorials: {
        id: 'gui.menuBar.tutorialsLibrary',
        defaultMessage: 'Tutorials',
        description: 'accessibility text for the tutorials button'
    }
});

const MenuBarItemTooltip = ({
    children,
    className,
    enable,
    id,
    place = 'bottom'
}) => {
    if (enable) {
        return (
            <React.Fragment>
                {children}
            </React.Fragment>
        );
    }
    return (
        <ComingSoonTooltip
            className={classNames(styles.comingSoon, className)}
            place={place}
            tooltipClassName={styles.comingSoonTooltip}
            tooltipId={id}
        >
            {children}
        </ComingSoonTooltip>
    );
};


MenuBarItemTooltip.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    enable: PropTypes.bool,
    id: PropTypes.string,
    place: PropTypes.oneOf(['top', 'bottom', 'left', 'right'])
};

const MenuItemTooltip = ({id, isRtl, children, className}) => (
    <ComingSoonTooltip
        className={classNames(styles.comingSoon, className)}
        isRtl={isRtl}
        place={isRtl ? 'left' : 'right'}
        tooltipClassName={styles.comingSoonTooltip}
        tooltipId={id}
    >
        {children}
    </ComingSoonTooltip>
);

MenuItemTooltip.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    id: PropTypes.string,
    isRtl: PropTypes.bool
};

const AboutButton = props => (
    <Button
        className={classNames(styles.menuBarItem, styles.hoverable)}
        iconClassName={styles.aboutIcon}
        iconSrc={aboutIcon}
        onClick={props.onClick}
    />
);

AboutButton.propTypes = {
    onClick: PropTypes.func.isRequired
};

class MenuBar extends React.Component {
    constructor (props) {
        super(props);
        bindAll(this, [
            'handleClickNew',
            'handleClickRemix',
            'handleClickSave',
            'handleClickSaveAsCopy',
            'handleClickSeeCommunity',
            'handleClickShare',
            'handleKeyPress',
            'handleLanguageMouseUp',
            'handleRestoreOption',
            'getSaveToComputerHandler',
            'restoreOptionMessage'
        ]);
    }
    componentDidMount () {
        document.addEventListener('keydown', this.handleKeyPress);
        this.props.checkAuth();
    }
    componentWillUnmount () {
        document.removeEventListener('keydown', this.handleKeyPress);
    }
    handleClickNew () {
        // if the project is dirty, and user owns the project, we will autosave.
        // but if they are not logged in and can't save, user should consider
        // downloading or logging in first.
        // Note that if user is logged in and editing someone else's project,
        // they'll lose their work.
        const readyToReplaceProject = this.props.confirmReadyToReplaceProject(
            this.props.intl.formatMessage(sharedMessages.replaceProjectWarning)
        );
        this.props.onRequestCloseFile();
        if (readyToReplaceProject) {
            if (this.props.assignmentId) {
                window.location.href = '/';
            } else {
                this.props.onClickNew(this.props.canSave && this.props.canCreateNew);
            }
        }
        this.props.checkAuth();
    }
    handleClickRemix () {
        this.props.onClickRemix();
        this.props.onRequestCloseFile();
    }
    handleClickSave (saveProjectCallback) {
        return () => {
            this.props.onClickSave();
            saveProjectCallback();
            this.props.onRequestCloseFile();
            if (this.props.onProjectTelemetryEvent) {
                const metadata = collectMetadata(this.props.vm, this.props.projectTitle, this.props.locale);
                this.props.onProjectTelemetryEvent('projectDidSave', metadata);
            }
        };
    }
    handleClickSaveAsCopy () {
        this.props.onClickSaveAsCopy();
        this.props.onRequestCloseFile();
    }
    handleClickOpenDetails () {
        this.props.onOpenDetailsProject(this.props.projectState)
        this.props.onRequestCloseFile();
    }
    handleClickSeeCommunity (waitForUpdate) {
        if (this.props.shouldSaveBeforeTransition()) {
            this.props.autoUpdateProject(); // save before transitioning to project page
            waitForUpdate(true); // queue the transition to project page
        } else {
            waitForUpdate(false); // immediately transition to project page
        }
    }
    handleClickShare (waitForUpdate) {
        if (!this.props.isShared) {
            if (this.props.canShare) { // save before transitioning to project page
                this.props.onShare();
            }
            if (this.props.canSave) { // save before transitioning to project page
                this.props.autoUpdateProject();
                waitForUpdate(true); // queue the transition to project page
            } else {
                waitForUpdate(false); // immediately transition to project page
            }
        }
    }
    handleRestoreOption (restoreFun) {
        return () => {
            restoreFun();
            this.props.onRequestCloseEdit();
        };
    }
    handleKeyPress (event) {
        const modifier = bowser.mac ? event.metaKey : event.ctrlKey;
        if (modifier && event.key === 's') {
            this.props.onClickSave();
            event.preventDefault();
        }
    }
    getSaveToComputerHandler (downloadProjectCallback) {
        return () => {
            this.props.onRequestCloseFile();
            downloadProjectCallback();
            if (this.props.onProjectTelemetryEvent) {
                const metadata = collectMetadata(this.props.vm, this.props.projectTitle, this.props.locale);
                this.props.onProjectTelemetryEvent('projectDidSave', metadata);
            }
        };
    }
    handleLanguageMouseUp (e) {
        if (!this.props.languageMenuOpen) {
            this.props.onClickLanguage(e);
        }
    }
    restoreOptionMessage (deletedItem) {
        switch (deletedItem) {
        case 'Sprite':
            return (<FormattedMessage
                defaultMessage="Restore Sprite"
                description="Menu bar item for restoring the last deleted sprite."
                id="gui.menuBar.restoreSprite"
            />);
        case 'Sound':
            return (<FormattedMessage
                defaultMessage="Restore Sound"
                description="Menu bar item for restoring the last deleted sound."
                id="gui.menuBar.restoreSound"
            />);
        case 'Costume':
            return (<FormattedMessage
                defaultMessage="Restore Costume"
                description="Menu bar item for restoring the last deleted costume."
                id="gui.menuBar.restoreCostume"
            />);
        default: {
            return (<FormattedMessage
                defaultMessage="Restore"
                description="Menu bar item for restoring the last deleted item in its disabled state." /* eslint-disable-line max-len */
                id="gui.menuBar.restore"
            />);
        }
        }
    }
    render () {
        const projectDetailsMessage = (
            <FormattedMessage
                defaultMessage="Details"
                description="Menu bar item for vewing project's details"
                id="gui.menuBar.details"
            />
        );
        const openProjectMessage = (
            <FormattedMessage
                defaultMessage="Open"
                description="Menu bar item for opening project"
                id="gui.menuBar.open"
            />
        );
        const saveMessage = (
            <FormattedMessage
                defaultMessage="Save"
                description="Menu bar item for saving a project"
                id="gui.menuBar.save"
            />
        );
        const saveNowMessage = (
            <FormattedMessage
                defaultMessage="Save now"
                description="Menu bar item for saving now"
                id="gui.menuBar.saveNow"
            />
        );
        const createCopyMessage = (
            <FormattedMessage
                defaultMessage="Save as a copy"
                description="Menu bar item for saving as a copy"
                id="gui.menuBar.saveAsCopy"
            />
        );
        const remixMessage = (
            <FormattedMessage
                defaultMessage="Remix"
                description="Menu bar item for remixing"
                id="gui.menuBar.remix"
            />
        );
        const newProjectMessage = (
            <FormattedMessage
                defaultMessage="New"
                description="Menu bar item for creating a new project"
                id="gui.menuBar.new"
            />
        );
        const remixButton = (
            <Button
                className={classNames(
                    styles.menuBarButton,
                    styles.remixButton
                )}
                iconClassName={styles.remixButtonIcon}
                iconSrc={remixIcon}
                onClick={this.handleClickRemix}
            >
                {remixMessage}
            </Button>
        );
        // Show the About button only if we have a handler for it (like in the desktop app)
        const aboutButton = this.props.onClickAbout ? <AboutButton onClick={this.props.onClickAbout} /> : null;
        return (
            <Box
                className={classNames(
                    this.props.className,
                    styles.menuBar
                )}
            >
                <div className={styles.mainMenu}>
                    <div className={styles.fileGroup}>
                        <div className={classNames(styles.menuBarItem)}>
                            <img
                                alt="Animaciones-logo"
                                className={classNames(styles.scratchLogo, {
                                    [styles.clickable]: typeof this.props.onClickLogo !== 'undefined'
                                })}
                                draggable={false}
                                src={this.props.logo}
                                // onClick={this.props.onClickLogo}
                            />
                        </div>
                        {(this.props.canChangeLanguage) && (<div
                            className={classNames(styles.menuBarItem, styles.hoverable, styles.languageMenu)}
                        >
                            <div>
                                <img
                                    className={styles.languageIcon}
                                    src={languageIcon}
                                />
                                <img
                                    className={styles.languageCaret}
                                    src={dropdownCaret}
                                />
                            </div>
                            <LanguageSelector label={this.props.intl.formatMessage(ariaMessages.language)} />
                        </div>)}
                        {(this.props.canManageFiles) && (
                            <React.Fragment>
                            <div
                                className={classNames(styles.menuBarItem, styles.hoverable, {
                                    [styles.active]: this.props.fileMenuOpen
                                })}
                                onMouseUp={this.props.onClickFile}
                            >
                                <FormattedMessage
                                    defaultMessage="File"
                                    description="Text for file dropdown menu"
                                    id="gui.menuBar.file"
                                />
                                <MenuBarMenu
                                    className={classNames(styles.menuBarMenu)}
                                    open={this.props.fileMenuOpen}
                                    place={this.props.isRtl ? 'left' : 'right'}
                                    onRequestClose={this.props.onRequestCloseFile}
                                >
                                    <MenuSection>
                                        <MenuItem
                                            isRtl={this.props.isRtl}
                                            onClick={this.handleClickNew}
                                        >
                                            {newProjectMessage}
                                        </MenuItem>
                                    </MenuSection>
                                    {(this.props.canSave || this.props.canCreateCopy || this.props.canRemix) && (
                                        <MenuSection>
                                            {this.props.canSave && this.props.sessionExists && this.props.username && (
                                                <MenuItem onClick={this.props.onOpenProject}>
                                                    {openProjectMessage}
                                                </MenuItem>
                                            )}
                                            {this.props.isShowingWithId && this.props.isMyProject && this.props.canSave && this.props.sessionExists && this.props.username && this.props.isAssignmentProjectDeliverable && (
                                                <EducabotSaver>{(className, saveProjectCallback) => (
                                                    <MenuItem
                                                        className={className}
                                                        onClick={this.handleClickSave(saveProjectCallback)}
                                                    >
                                                        {saveMessage}
                                                    </MenuItem>
                                                )}</EducabotSaver>
                                            )}
                                            {!this.props.isShowingWithId && this.props.canSave && this.props.sessionExists && this.props.username && this.props.isAssignmentProjectDeliverable && (
                                                <MenuItem onClick={this.props.onOpenSaveProject}>
                                                    {saveNowMessage}
                                                </MenuItem>
                                            )}
                                            {this.props.isShowingWithId && this.props.canSave && this.props.sessionExists && this.props.username && (
                                                <React.Fragment>
                                                    {(this.props.isAssignmentProjectDeliverable) ? (
                                                        <MenuItem onClick={this.props.onOpenRemixProject}>
                                                            {createCopyMessage}
                                                        </MenuItem>
                                                    ) : null}
                                                    <MenuItem onClick={() => {this.handleClickOpenDetails()}}>
                                                        {projectDetailsMessage}
                                                    </MenuItem>
                                                </React.Fragment>
                                            )}
                                            {this.props.canCreateCopy && (
                                                <MenuItem onClick={this.handleClickSaveAsCopy}>
                                                    {createCopyMessage}
                                                </MenuItem>
                                            )}
                                            {this.props.canRemix && (
                                                <MenuItem onClick={this.handleClickRemix}>
                                                    {remixMessage}
                                                </MenuItem>
                                            )}
                                        </MenuSection>
                                    )}
                                    <MenuSection>
                                        <SBFileUploader
                                            canSave={this.props.canSave}
                                            userOwnsProject={this.props.userOwnsProject}
                                        >
                                            {(className, renderFileInput, handleLoadProject) => (
                                                <MenuItem
                                                    className={className}
                                                    onClick={handleLoadProject}
                                                >
                                                    {/* eslint-disable max-len */}
                                                    {this.props.intl.formatMessage(sharedMessages.loadFromComputerTitle)}
                                                    {/* eslint-enable max-len */}
                                                    {renderFileInput()}
                                                </MenuItem>
                                            )}
                                        </SBFileUploader>
                                        <SB3Downloader>{(className, downloadProjectCallback) => (
                                            <MenuItem
                                                className={className}
                                                onClick={this.getSaveToComputerHandler(downloadProjectCallback)}
                                            >
                                                <FormattedMessage
                                                    defaultMessage="Save to your computer"
                                                    description="Menu bar item for downloading a project to your computer" // eslint-disable-line max-len
                                                    id="gui.menuBar.downloadToComputer"
                                                />
                                            </MenuItem>
                                        )}</SB3Downloader>
                                    </MenuSection>
                                </MenuBarMenu>
                            </div>
                            <div>
                                {(this.props.saveProjectOpenState || this.props.detailsProjectOpenState || this.props.remixProjectOpenState) && (
                                    <ProjectSaving
                                        isOpen={(this.props.saveProjectOpenState || this.props.detailsProjectOpenState || this.props.remixProjectOpenState)}
                                        isDetails={this.props.detailsProjectOpenState}
                                        isRemix={this.props.remixProjectOpenState}
                                    />
                                )}
                            </div>
                            </React.Fragment>
                        )}
                        <div
                            className={classNames(styles.menuBarItem, styles.hoverable, {
                                [styles.active]: this.props.editMenuOpen
                            })}
                            onMouseUp={this.props.onClickEdit}
                        >
                            <div className={classNames(styles.editMenu)}>
                                <FormattedMessage
                                    defaultMessage="Edit"
                                    description="Text for edit dropdown menu"
                                    id="gui.menuBar.edit"
                                />
                            </div>
                            <MenuBarMenu
                                className={classNames(styles.menuBarMenu)}
                                open={this.props.editMenuOpen}
                                place={this.props.isRtl ? 'left' : 'right'}
                                onRequestClose={this.props.onRequestCloseEdit}
                            >
                                <DeletionRestorer>{(handleRestore, {restorable, deletedItem}) => (
                                    <MenuItem
                                        className={classNames({[styles.disabled]: !restorable})}
                                        onClick={this.handleRestoreOption(handleRestore)}
                                    >
                                        {this.restoreOptionMessage(deletedItem)}
                                    </MenuItem>
                                )}</DeletionRestorer>
                                <MenuSection>
                                    <TurboMode>{(toggleTurboMode, {turboMode}) => (
                                        <MenuItem onClick={toggleTurboMode}>
                                            {turboMode ? (
                                                <FormattedMessage
                                                    defaultMessage="Turn off Turbo Mode"
                                                    description="Menu bar item for turning off turbo mode"
                                                    id="gui.menuBar.turboModeOff"
                                                />
                                            ) : (
                                                <FormattedMessage
                                                    defaultMessage="Turn on Turbo Mode"
                                                    description="Menu bar item for turning on turbo mode"
                                                    id="gui.menuBar.turboModeOn"
                                                />
                                            )}
                                        </MenuItem>
                                    )}</TurboMode>
                                </MenuSection>
                            </MenuBarMenu>
                        </div>
                    </div>
                    <Divider className={classNames(styles.divider)} />
                    {this.props.canShowTutorials ? (
                        <>
                            <div
                                aria-label={this.props.intl.formatMessage(ariaMessages.tutorials)}
                                className={classNames(styles.menuBarItem, styles.hoverable)}
                                onClick={this.props.onOpenTipLibrary}
                            >
                                {/* <img
                                    className={styles.helpIcon}
                                    src={helpIcon}
                                /> */}
                                <FormattedMessage {...ariaMessages.tutorials} />
                            </div>
                            <Divider className={classNames(styles.divider)} />
                        </>
                    ) : ('')}
                    {this.props.canEditTitle ? (
                        <div className={classNames(styles.menuBarItem, styles.growable)}>
                            <MenuBarItemTooltip
                                enable
                                id="title-field"
                            >
                                <ProjectTitleInput
                                    className={classNames(styles.titleFieldGrowable)}
                                />
                            </MenuBarItemTooltip>
                        </div>
                    ) : ((this.props.authorUsername && this.props.authorUsername !== this.props.username) ? (
                        <AuthorInfo
                            className={styles.authorInfo}
                            imageUrl={this.props.authorThumbnailUrl}
                            projectTitle={this.props.projectTitle}
                            userId={this.props.authorId}
                            username={this.props.authorUsername}
                        />
                    ) : null)}
                    <div className={classNames(styles.menuBarItem)}>
                        {this.props.canShare ? (
                            (this.props.isShowingProject || this.props.isUpdating) && (
                                <ProjectWatcher onDoneUpdating={this.props.onSeeCommunity}>
                                    {
                                        waitForUpdate => (
                                            <ShareButton
                                                className={styles.menuBarButton}
                                                isShared={this.props.isShared}
                                                /* eslint-disable react/jsx-no-bind */
                                                onClick={() => {
                                                    this.handleClickShare(waitForUpdate);
                                                }}
                                                /* eslint-enable react/jsx-no-bind */
                                            />
                                        )
                                    }
                                </ProjectWatcher>
                            )
                        ) : (
                            this.props.showComingSoon ? (
                                <MenuBarItemTooltip id="share-button">
                                    <ShareButton className={styles.menuBarButton} />
                                </MenuBarItemTooltip>
                            ) : []
                        )}
                        {this.props.canRemix ? remixButton : []}
                    </div>
                    <div className={classNames(styles.menuBarItem, styles.communityButtonWrapper)}>
                        {this.props.enableCommunity ? (
                            (this.props.isShowingProject || this.props.isUpdating) && (
                                <ProjectWatcher onDoneUpdating={this.props.onSeeCommunity}>
                                    {
                                        waitForUpdate => (
                                            <CommunityButton
                                                className={styles.menuBarButton}
                                                /* eslint-disable react/jsx-no-bind */
                                                onClick={() => {
                                                    this.handleClickSeeCommunity(waitForUpdate);
                                                }}
                                                /* eslint-enable react/jsx-no-bind */
                                            />
                                        )
                                    }
                                </ProjectWatcher>
                            )
                        ) : (this.props.showComingSoon ? (
                            <MenuBarItemTooltip id="community-button">
                                <CommunityButton className={styles.menuBarButton} />
                            </MenuBarItemTooltip>
                        ) : [])}
                    </div>
                </div>

                {/* show the proper UI in the account menu, given whether the user is
                logged in, and whether a session is available to log in with */}
                <div className={styles.accountInfoGroup}>
                    <div className={styles.menuBarItem}>
                        {this.props.canSave && (
                            <SaveStatus />
                        )}
                    </div>
                    {!process.env.IS_ELECTRON && this.props.canLogin ? (
                        this.props.sessionExists ? (
                            this.props.username ? (
                                // ************ user is logged in ************
                                <React.Fragment>
                                    <img
                                        className={styles.profileIcon}
                                        src={this.props.userData.avatarUrl}
                                    />
                                    {/* <span>
                                        {`${this.props.userData.name} ${this.props.userData.lastName}`}
                                    </span> */}
                                    <AccountNav
                                        className={classNames(
                                            styles.menuBarItem,
                                            styles.hoverable,
                                            {[styles.active]: this.props.accountMenuOpen}
                                        )}
                                        isOpen={this.props.accountMenuOpen}
                                        isRtl={this.props.isRtl}
                                        menuBarMenuClassName={classNames(styles.menuBarMenu)}
                                        onClick={this.props.onClickAccount}
                                        // onClose={() => {this.props.onRequestCloseAccount(); this.props.onRequestCloseProfile();}}
                                        onClose={this.props.onRequestCloseAccount}
                                        onLogOut={this.props.onLogOut}
                                        // onClickProfile={this.props.onClickProfile}
                                        onClickProfile={() => {}}
                                    />
                                    {/* <UserProfileSidebar userData={userData} state={openProfileState} updateProfileCallBack={this.updateProfileCallBack} closeCallBack={this.onCloseProfileSidebar} />, */}
                                    {/* <UserProfileSidebar userData={this.props.userData} state={this.props.openProfileState} /> */}
                                </React.Fragment>
                            ) : ('')
                        ) : (
                            // ******** no login session is available, so don't show login stuff
                            <React.Fragment>
                                <div
                                    className={classNames(
                                        styles.menuBarItem,
                                        styles.hoverable
                                    )}
                                    key="join"
                                    onMouseUp={this.props.onOpenRegistration}
                                >
                                    <FormattedMessage
                                        defaultMessage="Join Scratch"
                                        description="Link for creating a Scratch account"
                                        id="gui.menuBar.joinScratch"
                                    />
                                    {this.props.registrationOpenState && (
                                        <Scratch3Registration
                                            isOpen={this.props.registrationOpenState}
                                        />
                                    )}
                                </div>
                                <div
                                    className={classNames(
                                        styles.menuBarItem,
                                        styles.hoverable,
                                        styles.accountNavMenu
                                    )}
                                    onMouseUp={this.props.onClickLogin}
                                >
                                    <span>
                                        <FormattedMessage
                                            defaultMessage="Join Scratch"
                                            description="Link for creating a Scratch account"
                                            id="gui.menuBar.signIn"
                                        />
                                    </span>
                                    <LoginDropdown
                                        className={classNames(styles.menuBarMenu)}
                                        isOpen={this.props.loginMenuOpen}
                                        error={(this.props.loginError !== '') ? this.props.intl.formatMessage({ id: this.props.loginError }) : ''}
                                        onLogIn={this.props.onLoginSubmit}
                                        onClose={this.props.onRequestCloseLogin}
                                    />
                                </div>
                            </React.Fragment>
                        )
                    ) : ('')}
                </div>

                {aboutButton}
            </Box>
        );
    }
}

MenuBar.propTypes = {
    accountMenuOpen: PropTypes.bool,
    authorId: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    authorThumbnailUrl: PropTypes.string,
    authorUsername: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    autoUpdateProject: PropTypes.func,
    canChangeLanguage: PropTypes.bool,
    canCreateCopy: PropTypes.bool,
    canCreateNew: PropTypes.bool,
    canEditTitle: PropTypes.bool,
    canShowTutorials: PropTypes.bool,
    canManageFiles: PropTypes.bool,
    canRemix: PropTypes.bool,
    canSave: PropTypes.bool,
    canLogin: PropTypes.bool,
    canShare: PropTypes.bool,
    className: PropTypes.string,
    confirmReadyToReplaceProject: PropTypes.func,
    editMenuOpen: PropTypes.bool,
    enableCommunity: PropTypes.bool,
    fileMenuOpen: PropTypes.bool,
    intl: intlShape,
    isRtl: PropTypes.bool,
    isShared: PropTypes.bool,
    isShowingProject: PropTypes.bool,
    isUpdating: PropTypes.bool,
    isShowingWithId: PropTypes.bool,
    languageMenuOpen: PropTypes.bool,
    locale: PropTypes.string.isRequired,
    loginMenuOpen: PropTypes.bool,
    logo: PropTypes.string,
    onClickAbout: PropTypes.func,
    onClickAccount: PropTypes.func,
    onClickEdit: PropTypes.func,
    onClickFile: PropTypes.func,
    onClickLanguage: PropTypes.func,
    onClickLogin: PropTypes.func,
    onClickLogo: PropTypes.func,
    onClickNew: PropTypes.func,
    onClickRemix: PropTypes.func,
    onClickSave: PropTypes.func,
    onClickSaveAsCopy: PropTypes.func,
    onLogOut: PropTypes.func,
    onOpenRegistration: PropTypes.func,
    onOpenTipLibrary: PropTypes.func,
    onProjectTelemetryEvent: PropTypes.func,
    onRequestCloseAccount: PropTypes.func,
    onRequestCloseEdit: PropTypes.func,
    onRequestCloseFile: PropTypes.func,
    onRequestCloseLanguage: PropTypes.func,
    onRequestCloseLogin: PropTypes.func,
    onSeeCommunity: PropTypes.func,
    onShare: PropTypes.func,
    onToggleLoginOpen: PropTypes.func,
    projectTitle: PropTypes.string,
    renderLogin: PropTypes.func,
    sessionExists: PropTypes.bool,
    shouldSaveBeforeTransition: PropTypes.func,
    showComingSoon: PropTypes.bool,
    userOwnsProject: PropTypes.bool,
    username: PropTypes.string,
    userData: PropTypes.object,
    vm: PropTypes.instanceOf(VM).isRequired,
    checkAuth: PropTypes.func,
    onLoginSubmit: PropTypes.func,
    loginError: PropTypes.string,
    openProfileState: PropTypes.bool,
    registrationOpenState: PropTypes.bool,
    saveProjectOpenState: PropTypes.bool,
    detailsProjectOpenState: PropTypes.bool,
    remixProjectOpenState: PropTypes.bool,
    isMyProject: PropTypes.bool,
    onOpenProject: PropTypes.func,
    onCloseProjectLibrary: PropTypes.func,
    assignmentId: PropTypes.string,
    isAssignmentProjectDeliverable: PropTypes.bool,
};

MenuBar.defaultProps = {
    // logo: scratchLogo,
    logo,
    onShare: () => {}
};

const mapStateToProps = (state, ownProps) => {
    const loadingState = state.scratchGui.projectState.loadingState;

    let session = false;
    const sessionState = state.scratchGui.sessionReducer;
    if (sessionState.status === 'session_fetch' && sessionState.data.data.user) {
        session = sessionState.data.data;
        if (session.avatarUrl === '') {
            session.avatarUrl = '/static/assets/avatar_square_purple.png';
        }
    }

    const isMyProject = (
        session &&
        state.scratchGui.projectState.projectUserId &&
        state.scratchGui.projectState.projectUserId === session.userId.toString()
    ) ? true : false;
    // console.log('NEWPROPS', isMyProject, state.scratchGui.projectState);
    // console.log('NEWPROPS', loadingState, state.scratchGui.projectState);
    return {
        accountMenuOpen: accountMenuOpen(state),
        registrationOpenState: registrationOpenState(state),
        saveProjectOpenState: saveProjectOpenState(state),
        detailsProjectOpenState: detailsProjectOpenState(state),
        remixProjectOpenState: remixProjectOpenState(state),
        openProfileState: openProfileState(state),
        fileMenuOpen: fileMenuOpen(state),
        editMenuOpen: editMenuOpen(state),
        isRtl: state.locales.isRtl,
        isUpdating: getIsUpdating(loadingState),
        isShowingWithId: getIsShowingWithId(loadingState),
        isShowingProject: getIsShowingProject(loadingState),
        languageMenuOpen: languageMenuOpen(state),
        locale: state.locales.locale,
        loginMenuOpen: loginMenuOpen(state),
        loginError: (sessionState.status === 'login_error' && sessionState.data.error) ? sessionState.data.error : '',
        projectTitle: state.scratchGui.projectTitle,
        isMyProject: isMyProject,
        sessionExists: session && typeof session.user !== 'undefined',
        username: (session && session.email) ? session.email : 'Alumno Educabot',
        userData: (session) ? session : null,
        userOwnsProject: ownProps.authorUsername && session &&
            (ownProps.authorUsername === session.email),
        vm: state.scratchGui.vm,
        assignmentId: (state.scratchGui.projectState.assignmentId) ? state.scratchGui.projectState.assignmentId : null,
        isAssignmentProjectDeliverable: getIsAssignmentProjectDeliverable(state.scratchGui),
        projectState: state.scratchGui.projectState.projectDetails,
    };
};

const mapDispatchToProps = dispatch => ({
    checkAuth: () => dispatch(checkAuthAction()),
    autoUpdateProject: () => dispatch(autoUpdateProject()),
    onOpenTipLibrary: () => dispatch(openTipsLibrary()),
    onClickAccount: () => dispatch(openAccountMenu()),
    onClickProfile: () => dispatch(openProfileMenu()),
    onOpenRegistration: () => dispatch(openRegistrationMenu()),
    onRequestCloseRegistration: () => dispatch(closeRegistrationMenu()),
    onOpenSaveProject: () => dispatch(openSaveProjectMenu()),
    // onOpenDetailsProject: () => dispatch(openDetailsProjectMenu()),
    onOpenDetailsProject: (projectState) => dispatch(activateDeck(projectState)),
    onOpenRemixProject: () => dispatch(openRemixProjectMenu()),
    onOpenProject: () => dispatch(openProjectsLibrary()),
    onCloseProjectLibrary: () => dispatch(closeProjectsLibrary()),
    onRequestCloseSaveProject: () => dispatch(closeSaveProjectMenu()),
    onRequestCloseDetailsProject: () => dispatch(closeDetailsProjectMenu()),
    onRequestCloseRemixProject: () => dispatch(closeRemixProjectMenu()),
    onRequestCloseAccount: () => dispatch(closeAccountMenu()),
    onRequestCloseProfile: () => dispatch(closeProfileMenu()),
    onClickFile: () => dispatch(openFileMenu()),
    onRequestCloseFile: () => dispatch(closeFileMenu()),
    onClickEdit: () => dispatch(openEditMenu()),
    onRequestCloseEdit: () => dispatch(closeEditMenu()),
    onClickLanguage: () => dispatch(openLanguageMenu()),
    onRequestCloseLanguage: () => dispatch(closeLanguageMenu()),
    onClickLogin: () => dispatch(openLoginMenu()),
    onRequestCloseLogin: () => dispatch(closeLoginMenu()),
    onLogOut: () => dispatch(handleLogout()),
    onLoginSubmit: (formData, callback) => dispatch(handleLogin(formData, callback)),
    onClickNew: needSave => dispatch(requestNewProject(needSave)),
    onClickRemix: () => dispatch(remixProject()),
    onClickSave: () => dispatch(manualUpdateProject()),
    onClickSaveAsCopy: () => dispatch(saveProjectAsCopy()),
    onSeeCommunity: () => dispatch(setPlayer(true))
});

export default compose(
    injectIntl,
    MenuBarHOC,
    connect(
        mapStateToProps,
        mapDispatchToProps
    )
)(MenuBar);
